var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "kit-block kit-inspiration" }, [
    _c(
      "div",
      { staticClass: "kit-inspiration-slider" },
      [
        _c(
          "vueper-slides",
          {
            ref: "inspirationSlider",
            staticClass: "no-shadow",
            attrs: {
              touchable: false,
              fade: "",
              autoplay: false,
              bullets: false,
              arrows: false
            },
            on: { slide: _vm.slideChanged }
          },
          _vm._l(_vm.block.slides, function(slide, i) {
            return _c("vueper-slide", {
              key: i,
              staticClass: "center-slide",
              scopedSlots: _vm._u(
                [
                  {
                    key: "content",
                    fn: function() {
                      return [
                        _c(
                          "div",
                          { staticClass: "inspiration-slide-content" },
                          [
                            _c(
                              "div",
                              { staticClass: "slide-body" },
                              [
                                _c(
                                  "vueper-slides",
                                  {
                                    ref: "venueSlider_" + i,
                                    refInFor: true,
                                    staticClass: "no-shadow",
                                    attrs: {
                                      touchable: false,
                                      fade: "",
                                      autoplay: false,
                                      bullets: false,
                                      arrows: false
                                    }
                                  },
                                  _vm._l(slide.venues, function(venue, v) {
                                    return _c("vueper-slide", {
                                      key: v,
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "content",
                                            fn: function() {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "venue-content"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "venue-info"
                                                      },
                                                      [
                                                        _c("h3", {
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              slide.headline
                                                            )
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c("h4", {
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              venue.item.name
                                                            )
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c("p", {
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              venue.description
                                                            )
                                                          }
                                                        })
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "venue-image"
                                                      },
                                                      [
                                                        _c("img", {
                                                          attrs: {
                                                            src:
                                                              venue.image.sizes
                                                                .large
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            },
                                            proxy: true
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    })
                                  }),
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                true
              )
            })
          }),
          1
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "nav-prev arrow-nav",
            on: {
              click: function($event) {
                return _vm.$refs.inspirationSlider.previous()
              }
            }
          },
          [
            _c("svg", { staticClass: "circle-border" }, [
              _c("circle", { attrs: { cx: "50%", cy: "50%", r: "46%" } })
            ]),
            _vm._v(" "),
            _c("i", { staticClass: "fas fa-angle-left" })
          ]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "nav-next arrow-nav",
            on: {
              click: function($event) {
                return _vm.$refs.inspirationSlider.next()
              }
            }
          },
          [
            _c("svg", { staticClass: "circle-border" }, [
              _c("circle", { attrs: { cx: "50%", cy: "50%", r: "46%" } })
            ]),
            _vm._v(" "),
            _c("i", { staticClass: "fas fa-angle-right" })
          ]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "inspiration-nav-footer" },
      [
        _c(
          "vueper-slides",
          {
            ref: "slideVenueNavs",
            staticClass: "no-shadow",
            staticStyle: { "margin-bottom": "0", "flex-grow": "1" },
            attrs: {
              touchable: false,
              autoplay: false,
              bullets: false,
              arrows: false,
              "fixed-height": "80px"
            }
          },
          _vm._l(_vm.block.slides, function(slide, s) {
            return _c("vueper-slide", {
              key: "ss-" + s,
              scopedSlots: _vm._u(
                [
                  {
                    key: "content",
                    fn: function() {
                      return [
                        _c(
                          "div",
                          { staticClass: "inspiration-slide-nav-thumbs" },
                          [
                            _c(
                              "vueper-slides",
                              {
                                ref: "venueNav_" + s,
                                refInFor: true,
                                staticClass: "no-shadow",
                                staticStyle: { "margin-bottom": "0" },
                                attrs: {
                                  touchable: false,
                                  "visible-slides": 3,
                                  gap: 2,
                                  "slide-ratio": 1 / 2,
                                  autoplay: false,
                                  bullets: false,
                                  breakpoints: {
                                    700: { slideRatio: 1 / 3 }
                                  },
                                  arrows: false,
                                  "fixed-height": "80px"
                                },
                                on: {
                                  slide: function($event) {
                                    return _vm.changeVenue(s, $event)
                                  }
                                }
                              },
                              _vm._l(slide.venues, function(venue, v) {
                                return _c("vueper-slide", {
                                  key: "v-" + v,
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "content",
                                        fn: function() {
                                          return [
                                            _c(
                                              "a",
                                              {
                                                staticClass: "nav-thumb",
                                                class: {
                                                  active:
                                                    v == _vm.ui.currentVenue
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.setVenueSlide(
                                                      s,
                                                      v
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: venue.image.sizes.large
                                                  }
                                                })
                                              ]
                                            )
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              }),
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "nav-prev tiny-arrow-nav",
                                on: {
                                  click: function($event) {
                                    return _vm.prevVenueThumb(s)
                                  }
                                }
                              },
                              [_c("i", { staticClass: "fas fa-angle-left" })]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "nav-next tiny-arrow-nav",
                                on: {
                                  click: function($event) {
                                    return _vm.nextVenueThumb(s)
                                  }
                                }
                              },
                              [_c("i", { staticClass: "fas fa-angle-right" })]
                            )
                          ],
                          1
                        )
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                true
              )
            })
          }),
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "inspiration-bullets" }, [
          _c("h4", { domProps: { innerHTML: _vm._s(_vm.block.title) } }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "inspiration-nav" },
            _vm._l(_vm.block.slides, function(item, index) {
              return _c(
                "a",
                {
                  key: "nav-" + index,
                  staticClass: "nav-bullet",
                  class: { active: _vm.ui.currentSlide == index },
                  on: {
                    click: function($event) {
                      return _vm.$refs.inspirationSlider.goToSlide(index)
                    }
                  }
                },
                [_c("span")]
              )
            }),
            0
          )
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /Users/nick/Desktop/Projects/kinston/wp-content/themes/kinston/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/Users/nick/Desktop/Projects/kinston/wp-content/themes/kinston/node_modules/vue-loader/lib?{}!/Users/nick/Desktop/Projects/kinston/wp-content/themes/kinston/node_modules/vue-svg-inline-loader/dist/index.min.js?{}!./scripts/components/KitBlocks/KitInspiration.vue?vue&type=template&id=05e956e5&
// module id = 530
// module chunks = 0